var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 262,
    viewBox: "0 0 195 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7374_20954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 217
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H91.3314V216.187H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7374_20954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3601 194.729L14.4873 215.695C7.27564 217.89 0 212.471 0 204.904V11.283C0 3.66037 7.37641 -1.76555 14.6148 0.532695L83.4876 22.3992C88.1572 23.8822 91.3314 28.2324 91.3314 33.1499V183.939C91.3314 188.906 88.0943 193.288 83.3601 194.729",
    fill: "black"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5899 25.5389C57.5899 27.295 56.6165 28.7185 55.4158 28.7185C54.2152 28.7185 53.2418 27.295 53.2418 25.5389C53.2418 23.7829 54.2152 22.3594 55.4158 22.3594C56.6165 22.3594 57.5899 23.7829 57.5899 25.5389",
    fill: "#697079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1604 27.0507C62.1604 28.1438 61.5543 29.0302 60.807 29.0302C60.0593 29.0302 59.4532 28.1438 59.4532 27.0507C59.4532 25.9577 60.0593 25.0713 60.807 25.0713C61.5543 25.0713 62.1604 25.9577 62.1604 27.0507",
    fill: "#697079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0721 25.6943V186.915L90.0893 168.833V44.554L10.0721 25.6943Z",
    fill: "#774331"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0721 166.882L90.0893 153.306V149.384L10.0721 161.798V166.882Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0891 86.8781L10.072 80.7715V85.7277L90.0891 90.7014V86.8781Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0891 118.609L10.072 121.905V126.83L90.0891 122.409V118.609Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0721 45.6291L90.0893 59.7685V55.9137L10.0721 40.6318V45.6291Z",
    fill: "#B26E4B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.658 247.407V243.13L144.069 243.069L143.926 249.671L134.605 256.491L130.658 247.407Z",
    fill: "#C962A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.042 247.407V243.13L175.453 243.069L175.31 249.671L165.989 256.491L162.042 247.407Z",
    fill: "#C962A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.229 51.4652C127.229 51.4652 126.742 52.5043 126.706 51.8987C124.515 51.0121 126.921 47.0815 125.616 44.5115C124.885 43.0723 124.456 41.5583 124.306 40.0746C124.912 39.7922 125.518 39.512 126.126 39.2359L127.229 38.2144C129.764 36.6152 132.964 36.8122 134.38 37.4788C139.388 39.8361 134.424 45.303 134.842 45.134C132.952 47.4423 127.229 51.4652 127.229 51.4652Z",
    fill: "#EFB87B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7374_20954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 38,
    width: 33,
    height: 61
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.353 97.9473L106.644 98.4833L105.609 39.1863L136.318 38.6503L137.353 97.9473Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7374_20954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.2 54.3907C105.329 59.5072 104.682 67.2256 108.635 73.0448L127.343 101.027C129.516 104.226 130.218 98.4675 133.448 96.2361C136.561 94.0851 138.821 88.0432 136.713 84.9395C136.713 84.9395 139.33 78.2507 138.441 76.5156C138.113 75.8773 133.816 76.8284 133.448 76.344C130.261 72.1463 121 64.2416 121 64.2416L132.553 50.0992C131.798 46.9184 129.031 42.504 125.451 38.8401L110.2 54.3907Z",
    fill: "#47C2BB"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.663 261.828L175.311 249.671L170.973 252.69C170.973 252.69 173.269 247.406 162.043 247.406C161.73 251.255 159.22 254.591 155.575 256.002L147.688 258.028C147.332 258.193 147.078 258.51 146.98 258.881L146.936 261.9H175.711L175.663 261.828Z",
    fill: "#5E3A30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.663 72.3705L155.495 54.5784L144.081 47.3984L143.334 74.8654C133.806 78.4807 132.531 82.2484 132.531 89.5516L167.997 86.9891C167.997 79.6866 167.032 73.6374 155.663 72.3705",
    fill: "#EFB87B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.977 73.403C159.203 72.8713 157.407 72.4845 155.663 72.29L142.234 83.0518L142.831 74.6137C142.041 74.8287 141.279 75.0604 140.54 75.3068C140.648 75.1409 133.089 76.6326 133.201 76.4684C123.15 79.382 128.936 83.5692 127.343 89.5515C115.238 125.208 128.072 142.236 128.072 142.236L173.27 142.236C173.27 142.236 177.709 84.0967 175.854 82.2101C171.645 76.9103 167.091 74.5618 160.977 73.403Z",
    fill: "#47C2BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.737 243.255H175.632C175.632 243.255 173.269 208.282 173.269 142.236H128.072C123.003 173.938 129.649 243.264 129.649 243.264H144.758L147.238 174.316H151.476C153.305 205.987 158.737 243.255 158.737 243.255",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7374_20954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 247,
    width: 32,
    height: 15
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 247.407H144.327V262H113V247.407Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7374_20954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.323 261.901H144.327L144.323 261.897L143.926 249.672L134.486 252.691C134.486 252.691 135.541 247.61 130.658 247.407C130.346 251.256 127.835 254.592 124.191 256.003L113.752 258.029C113.396 258.194 113.142 258.511 113.045 258.882L113 261.901H141.24L144.327 262.001L144.323 261.901Z",
    fill: "#5E3A30"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.519 42.4082L158.598 43.5341L155.576 63.1047L152.306 53.3229L144.758 52.1624L148.519 42.4082Z",
    fill: "#78868E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.306 53.3224C153.509 60.7319 146.786 67.3257 141.999 68.0815C137.212 68.8373 136.217 64.2981 134.728 55.4699C134.014 51.2359 133.162 47.9836 135.119 44.3385C137.077 40.6934 139.712 40.3758 142.181 39.5049C151.614 40.3088 149.972 47.7027 148.077 48.7664L152.306 53.3224",
    fill: "#EFB87B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.545 36.8887L129.218 38.3921C129.218 38.3921 141.986 39.1076 145.014 41.8909C147.62 44.2852 155.636 47.2044 157.822 47.9721C158.121 48.0769 158.442 47.9058 158.518 47.603L159.996 41.6971C160.526 39.5791 159.224 37.4257 157.083 36.8626C143.33 33.2426 133.182 34.4578 129.465 35.145C128.66 35.2939 128.213 36.1458 128.545 36.8887",
    fill: "#5E3A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.756 58.771C139.729 58.7753 139.702 58.7753 139.674 58.7704C139.618 58.7612 138.282 58.5365 137.692 57.7261C137.13 56.9541 137.473 52.6818 137.547 51.8331C137.559 51.6948 137.684 51.5921 137.823 51.6045C137.964 51.6164 138.068 51.738 138.056 51.8768C137.877 53.9098 137.775 56.9773 138.107 57.4322C138.495 57.9665 139.43 58.221 139.757 58.2739C139.896 58.2966 139.99 58.4263 139.967 58.5635C139.949 58.6726 139.861 58.7542 139.756 58.771",
    fill: "#EFB87B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.915 56.744C141.596 56.8239 139.637 55.0271 139.548 52.7388C139.459 50.4505 141.273 48.5244 143.593 48.4445C145.912 48.3646 147.871 50.1608 147.96 52.4491C148.049 54.7374 146.234 56.6641 143.915 56.744M132.189 57.1478C129.87 57.2277 127.911 55.431 127.822 53.1432C127.733 50.8549 129.548 48.9282 131.867 48.8483C134.186 48.7684 136.145 50.5651 136.234 52.8534C136.323 55.1412 134.508 57.0678 132.189 57.1478M143.563 47.6898C140.822 47.7843 138.678 50.0613 138.783 52.7653C138.787 52.8501 138.798 52.9326 138.806 53.0163L136.995 53.0786C136.996 52.9949 137.002 52.9118 136.999 52.827C136.894 50.1225 134.578 47.9995 131.838 48.0936C129.096 48.1881 126.952 50.4651 127.057 53.1696C127.162 55.8735 129.477 57.997 132.218 57.9025C134.61 57.82 136.546 56.076 136.932 53.8367L138.928 53.7678C139.486 55.9749 141.553 57.5807 143.944 57.4987C146.685 57.4041 148.83 55.1272 148.725 52.4227C148.62 49.7187 146.305 47.5953 143.563 47.6898",
    fill: "#3B3F41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 26_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.423 142.237H157.768C158.686 139.079 163.029 135.413 163.029 135.413C163.029 135.413 166.307 133.053 166.601 133.652C169.19 133.608 168.447 138.636 170.862 140.683C172.214 141.829 173.294 143.181 174.08 144.623C173.59 145.171 173.099 145.717 172.604 146.259L171.408 147.561L171.419 147.569C171.004 148.224 168.726 150.173 168.217 150.685C168.217 150.685 164.248 146.919 162.423 142.237",
    fill: "#EFB87B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7374_20954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 80,
    width: 34,
    height: 66
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 29_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.367 80.0918H195V145.507H161.367V80.0918Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7374_20954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 28_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.269 145.507L190.264 128.651C195.695 123.102 196.551 114.602 192.334 108.108L176.076 82.6064C173.757 79.0359 169.189 79.6555 165.61 82.0543C162.161 84.3665 160.048 91.7231 162.297 95.1867L178.628 117.579L165.709 132.954C166.474 136.476 169.42 141.398 173.269 145.507",
    fill: "#47C2BB"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.737 75.1842L138.441 90.2805L142.315 83.194L146.605 91.5387L158.598 72.9201L155.536 70.1523L142.778 81.2226L143.288 72.1648L140.737 75.1842Z",
    fill: "#FFCC66"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/NoSearchResults.7f85982dd4e690221a3d8e729bf40797.svg";
export { ForwardRef as ReactComponent };